import { livestreamStore } from '../../ng-services/livestreams/livestream.store';

export class LivestreamComponent {
    constructor(protected $window: ng.IWindowService) {}

    get streamUrl() {
        if (this.livestream?.provider === 'youtube') {
            return this.livestream?.stream_url;
        }

        // todo: handle different providers
        return 'todo';
    }

    get livestream() {
        return livestreamStore.active;
    }

    openInNewWindow() {
        this.$window.open(
            this.streamUrl,
            'livestream_window',
            'width=1260,height=720,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=yes'
        );
        livestreamStore.stop();
    }

    close() {
        livestreamStore.stop();
    }
}

angular.module('tradersyard').component('tyLivestream', {
    // language=HTML
    template: `
        <div class="livestream">
            <div class="livestream__bar" is-uib>
                <button class="btn" ng-click="$ctrl.close()">
                    <i class="fa fa-times"></i>
                </button>
                <button class="btn" ng-click="$ctrl.openInNewWindow()">
                    <span class="livestream__open_in_window"></span>
                </button>
            </div>
            <iframe
                class="livestream__iframe" ng-src="{{$ctrl.streamUrl | insecureUrl}}"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
            ></iframe>
        </div>
    `,
    controller: LivestreamComponent,
});
